/**
 * Print utility for Orders
 * Used by OrderHistoryPage and AccountOrdersPage
 */

export const printOrder = (printRef, orderData) => {
  if (!printRef || !printRef.current) {
    console.error('Print ref is not available');
    return;
  }

  // Create a hidden iframe for printing
  const printFrame = document.createElement('iframe');
  printFrame.style.position = 'absolute';
  printFrame.style.width = '0';
  printFrame.style.height = '0';
  printFrame.style.border = 'none';

  document.body.appendChild(printFrame);

  // Get the PDF component HTML
  const printContent = printRef.current;

  // Build the complete HTML document
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
        <title>Order #${orderData?.id || "Draft"}</title>
        <style>
            body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
            }
            @media print {
                body {
                    margin: 0;
                    padding: 0;
                }
                .order-pdf {
                    margin: 0 !important;
                    padding: 0.5in !important;
                }
                .order-pdf > div:nth-last-child(3),
                .order-pdf > div:nth-last-child(2) {
                    page-break-inside: avoid;
                    break-inside: avoid;
                }
            }
            @page {
                margin: 0.5in;
                size: letter;
            }
            .page-break-avoid {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
            }
        </style>
    </head>
    <body>
        ${printContent.innerHTML}
    </body>
    </html>
  `;

  // Write content to iframe using modern approach
  const iframeDoc = printFrame.contentDocument || printFrame.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(htmlContent);
  iframeDoc.close();

  // Single print trigger with cleanup
  setTimeout(() => {
    try {
      printFrame.contentWindow.focus();
      printFrame.contentWindow.print();
    } catch (error) {
      console.error('Print error:', error);
    } finally {
      // Cleanup after print dialog is handled
      setTimeout(() => {
        if (document.body.contains(printFrame)) {
          document.body.removeChild(printFrame);
        }
      }, 1000);
    }
  }, 500);
};